import { Component, type ReactNode } from 'react';
import { CherryMascot } from './CherryMascot';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] px-4 text-center">
          <div className="mb-4"><CherryMascot mood="error" size={48} /></div>
          <h2 className="text-xl font-bold mb-2">Something went wrong</h2>
          <p className="text-text-secondary text-sm mb-4 max-w-md">
            The app hit an unexpected error. Try reloading — if it keeps happening, tap the feedback button to let us know.
          </p>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
            className="px-4 py-2 bg-cherry-500 hover:bg-cherry-600 text-white text-sm font-semibold rounded-lg transition-colors"
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
